import React, { useState, useEffect } from "react";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../services/api/API";
import { showCustomAlert } from "../../../../customComponents/CustomSweetAlert";

const StockInSerialForm = ({ formData,setFormData,itemNameData,poIdValue,showroomIdVal,poDetailsId,businessPartnerIdValue,serialData,serialID,fetchDepartments=()=>{},iseditmode,setisEditMode,toggleSerialDrawer, itemTypeValue, poStockInId}) => {
  // const [formData, setFormData] = useState({

  // });
  console.log("serialData",serialData);
  
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [ userTypedd, setUserTypedd ] = useState([])
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
const location = useLocation()
  const userType = localStorage.getItem("UserType")
  console.log(userType, "usertype")
//   const [iseditmode, setisEditMode] = useState(false);

  const businessPartnerId = location?.state?.data?.business_partner_id
  console.log("businesspartnerID",businessPartnerId);
  
  const POID = location?.state?.data?.po_id
 
  const PODETAILSID = location?.state?.data?.po_details_id
  const SHOWROOMID = location?.state?.data?.showroom_id
  const ITEMTYPE = location?.state?.data?.item_type
  console.log("ITEMTYPE",location);



//   useEffect(() => {
//     const fetchSparePartExistingDetails = async () => {
//       console.log("serialData",serialData);

//       try {
//         const response = await axiosInstance.get(
//           `/Postockin/srnoedit/${serialID}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         if (response.status === 200) {
//           const vehicleData = response.data.data;
//           console.log("vehicledata", vehicleData, response);

//           const transformedData = {
//             business_partner_id: vehicleData?.business_partner_id,
//             chassisno: vehicleData.chassis_no,
//             engineno: vehicleData.engine_no,
//             serialno: vehicleData?.serial_no,
//           };

//           setFormData(transformedData);

//           console.log(
//             "Transformed vehicle data set to formData:",
//             transformedData
//           );
//         } else {
//           console.error("Failed to fetch vehicle data");
//         }
//       } catch (error) {
//         console.error("Error fetching vehicle data:", error);
//       }
//     };

//     if (iseditmode) {
//       console.log("iseditmode", iseditmode);

//       fetchSparePartExistingDetails();
//     }
//   }, [iseditmode]);


  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    VehicleInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    setIsLoading(true);
    console.log("formData", formData);

    try {
      if (iseditmode) {
        const payload = {
          chassis_no: itemNameData === "Vehicle" ? formData?.chassisno : null,
          engine_no: itemNameData === "Vehicle" ? formData?.engineno : null,
          business_partner_id:businessPartnerIdValue || businessPartnerId,
          po_id:poIdValue || POID,
          po_details_id:poDetailsId || PODETAILSID,
          showroom_id:showroomIdVal || SHOWROOMID ,
          itemtype:itemTypeValue || ITEMTYPE,
          serial_no: formData?.serialno
        };


        const response = await axiosInstance.patch(
          `/Postockin/srnoupdate/${poStockInId}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Unit added successfully:", response.data);
      fetchDepartments()
      toggleSerialDrawer();
        setisEditMode(false)
      } else {
        const payload = {
          phystkinitem_id: serialData?.phystkin_item_id,
          chassis_no: itemNameData === "Vehicle" ? formData?.chassisno : null,
          engine_no: itemNameData === "Vehicle" ? formData?.engineno : null,
          business_partner_id:businessPartnerIdValue ||businessPartnerId,
          po_id:poIdValue||POID,
          po_details_id:poDetailsId || PODETAILSID,
          showroom_id:showroomIdVal || SHOWROOMID ,
          itemtype:itemTypeValue || ITEMTYPE,
          serial_no: formData?.serialno
        };

        // if (userType === "superadmin") {
        //   payload.business_partner_id = formData.business_partner_id;
        // } else {
        //   payload.business_partner_id = businessPartnerId;
        // }

        const response = await axiosInstance.post(
          "/Postockin/srnocreate",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        fetchDepartments()
        toggleSerialDrawer()
        console.log("Unit added successfully:", response.data);
       
      }

      //navigate('/logistics/manage-stock/physical-stock-taking');
    } catch (error) {
      console.error("Error adding data:", error);

      console.error("Error submitting form:", error);
    } finally {
      setIsLoading(false);
    }
    console.log("clicked");
  };

  const VehicleInputs = [

    ...(itemNameData === "Vehicle"?[
      {
        name: "chassisno",
        label: "Chassis No.",
        type: "text",
        placeholder: "Enter Chassis No.",
        // options: logisticComapanies,
        // disabled: fieldsdisabled,
        validation: { required: true },
        required: true,
        gridClass: "col-lg-3",
      },
    ] : [] ),
    ...(itemNameData === "Vehicle"?[
      {
        name: "engineno",
        label: "Engine No.",
        type: "text",
        placeholder: "Enter Engine No.",
        validation: { required: true },
        required: true,
        gridClass: "col-lg-3",
      },
    ] : [] ),
    
      {
        name: "serialno",
        label: "Serial No.",
        type: "text",
        placeholder: "Enter Serial No.",
        validation: { required: true },
        required: true,
        gridClass: "col-lg-3",
      },
   
  ];

  // const VehicleInputs = [
  //   {
  //     name:"business_partner_id",
  //     label:"Business Partner",
  //     type:"dropdown",
  //     required:true,
  //     options:userTypedd,
  //     gridClass: "col-lg-4",
  //     validation: { required: true,
  //       pattern: /^[A-Za-z0-9 ]*$/,
  //       message: "Only alphabets and digits are allowed",
  //      },
  //   },
  //   {
  //     name: "product_name",
  //     label: "Name",
  //     type: "text",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: {
  //       required: true,
  //       pattern: /^[A-Za-z0-9 ]*$/,
  //       message: "Only alphabets and digits are allowed",
  //     },
  //   },
  //   {
  //     name: "description",
  //     label: "Description",
  //     type: "text",
  //     required: true,
  //     gridClass: "col-lg-4",
  //     validation: { required: true },
  //   },
  //   {
  //     name: "status",
  //     label: "Status Name",
  //     type: "dropdown",
  //     required: true,
  //     options: [
  //       { id:1, label: "Active", value: "Active" },
  //       { id:0, label: "Inactive", value: "Inactive" },
  //     ],
  //     gridClass: "col-lg-4",
  //     validation: { required: true },
  //   },
  // ];

  return (
    <>
     
     <div>
        <DynamicForm
          formConfig={VehicleInputs}
          formData={formData}
          setFormData={setFormData}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>

      <div className="btncontainer mt-3">
        <button onClick={()=>handleFormSubmit(formData)} className="submit-btn">
          {isLoading ? <div className="spinner"></div> : "Submit"}
        </button>
      </div>
      {/* <div className="btncontainer mt-3">
        <button onClick={handleSubmit} className="submit-btn">
          {isLoading ? "Submitting..." : "Submit"}
        </button>
      </div> */}
    </>
  );
};

export default StockInSerialForm;
